import React from 'react';
import { Box, Typography, Button, InputAdornment } from '@mui/material';
import { Person as PersonIcon, Email as EmailIcon } from '@mui/icons-material';
import { FormProvider } from 'react-hook-form';
import FormTextField from '../../formElements/textfield';

const UserInfoForm = ({
  formMethods,
  isPending,
  onSubmit,
}) => {
  return (
    <Box className="user-info-form">
      <Typography variant="h6" className="form-title">
        Let's get started
      </Typography>
      <Typography variant="body2" className="form-subtitle">
        Please provide your details to start the conversation
      </Typography>
      
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)} className="user-form">
          <FormTextField
            name="customer_name"
            label="Your Name"
            className="form-field"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon className="field-icon" />
                </InputAdornment>
              ),
            }}
          />
          
          <FormTextField
            name="customer_email"
            label="Email Address"
            type="email"
            className="form-field"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon className="field-icon" />
                </InputAdornment>
              ),
            }}
          />
          
          <Button
            type="submit"
            variant="contained"
            fullWidth
            className="start-chat-button"
            disabled={isPending}
          >
            {isPending ? 'Starting...' : 'Start Chat'}
          </Button>
        </form>
      </FormProvider>
    </Box>
  );
};

export default UserInfoForm;
